import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import { Grid, Stack, Toolbar, Typography, Box } from "@mui/material";
import logo from "./../images/logo.png";
import "./../header/Header.css";
import { ComBtn } from "../commonFields/ComBtn";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from '@mui/material/IconButton';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom"; // Import useNavigate from React Router


const MainHeader = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const bMediaQuery = useMediaQuery("(max-width:2000px)");
  const aMediaQuery = useMediaQuery("(min-width: 365px) and (max-width: 450px)");
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate(); // Initialize the navigate function
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    navigate('/about'); // Navigate to the About page when the button is clicked
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page
    setAnchorEl(null);
  };


  const handleAboutClick = () => {
    navigate('/about'); // Navigate to the About page when the button is clicked
  };

  const handleClick = () => {
    // navigate('/about'); // Navigate to the About page when the button is clicked
    const footerElement = document.getElementById('contactInfo'); // Get the footer element by ID
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: 'smooth' }); // Scroll to the footer element
    }
    setAnchorEl(null);
  };


  const heading = {
    fontWeight: 800,
    fontSize: aMediaQuery ? "22px" : vMediaQuery ? '18px' : "48px",
    marginLeft: aMediaQuery || vMediaQuery ? "10px" : "0px",
    paddingX: aMediaQuery || vMediaQuery ? '10px' : '',
    fontFamily: "EB Garamond",
    backgroundImage: "linear-gradient(5deg, #07cd07, #eaff63, green)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
  };

  const header = {
    background: 'linear-gradient(65deg, #acd3fa, #99ff99, #acd3fa)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 800,
    fontSize: vMediaQuery ? "26px" : "48px",
    fontFamily: "EB Garamond",
  }


  useEffect(() => {
    let scrollTimer = null;

    const handleScroll = () => {
      clearTimeout(scrollTimer); // Clear any existing timer

      scrollTimer = setTimeout(() => {
        if (window.scrollY > 0) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }, 500); // Set the delay in milliseconds
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimer); // Clear the timer on unmount
    };
  }, []);


  return (
    <>

      <header className="main-header" id="logoElmt">
        <AppBar
          className={`main-header ${isScrolled ? 'hidden' : 'unhidden'}`}
          position="absolute"
          sx={{
            background: isScrolled ? "transparent" : "transparent",
            boxShadow: 0,
            padding: vMediaQuery ? "6px" : "",
            display: isScrolled ? "none" : "block",
          }}
        >
          <Toolbar>
            <Grid container>
              <Grid item xs={2} sm={3} md={3} lg={3}
              >
                <div className="logo-contanier">
                  <img className="logo" src={logo} alt="Logo" title="GDR Consultancy Services" />
                </div>
              </Grid>
              <Grid
                item
                xs={8}
                sm={6}
                md={6}
                lg={6}
                sx={{ textAlign: "center", paddingX: vMediaQuery ? "" : "10px", paddingTop: vMediaQuery ? "" : "20px", paddingBottom: vMediaQuery ? "" : "10px", }}
              >
                <Typography variant="h4" sx={heading} className="logo-name">
                  GDR Consultancy Services
                </Typography>
              </Grid>
              <Grid item xs={2} sm={3} md={3} lg={3}
              >
                <Stack
                  direction={"row"}
                  spacing={vMediaQuery ? 0 : 2}
                  sx={{
                    justifyContent: vMediaQuery ? "center" : "flex-end",
                    padding: vMediaQuery ? "0px" : "20px 40px",
                    marginLeft:aMediaQuery ? '12px' : "10px",
                    marginTop: aMediaQuery ? '12px' : vMediaQuery ? "4px" : bMediaQuery ? '16px' : "20px",
                  }}
                >
                  {!vMediaQuery &&
                    <>
                      <ComBtn className={"btn"} onClick={handleAboutClick} text={"About Us"} />

                      <ComBtn className={"btn"} onClick={handleClick} text={"Contact Us"} />
                    </>
                  }
                  {vMediaQuery &&
                    <>
                      <Avatar variant="rounded" sx={{
                        width: 32, height: 32,
                        background: "green",
                        color: "#f0f4f5", textAlign: "center"
                      }}>
                        <IconButton sx={{
                          background: "green",
                          color: "#f0f4f5",
                          padding: "8px",
                        }}
                          aria-label="more"
                          id="long-button"
                          aria-controls={open ? 'long-menu' : undefined}
                          aria-expanded={open ? 'true' : undefined}
                          aria-haspopup="true"
                          onClick={handleMenu}
                        >
                          <MenuRoundedIcon />
                        </IconButton>
                      </Avatar>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem onClick={handleClose}>About Us</MenuItem>
                        <MenuItem onClick={handleClick}>Contact Us</MenuItem>
                      </Menu>
                    </>
                  }
                </Stack>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <div style={{ margin: vMediaQuery ? "100px 20px" : "200px 80px" }}>
          <Box
            sx={{ flexGrow: 1, padding: vMediaQuery ? "0px 16px" : "0px 60px 0px 40px" }}
          >
            <Grid container className="about-head">
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  sx={header}
                >
                  Trusted Microsoft Dynamics 365 for CRM & ERP implementation, upgrade and support
                </Typography>
                <h1
                  style={{
                    color: "#c3e077",
                    fontWeight: 600,
                    fontSize: vMediaQuery ? "16px" : "32px",
                    marginTop: vMediaQuery ? "30px" : "50px"
                  }}
                >
                  We help companies succeed with the right strategy, technology, and solutions.
                </h1>
              </Grid>
            </Grid>
          </Box>
        </div>
      </header>
    </>
  );
};

export default MainHeader;
